<script>
let customerId = window.localStorage.getItem("customerId");
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import ImportDeviceType from "./importDeviceType.vue";
import config from "@/../config";

export default {
  extends: baseList,
  components: {
    ImportDeviceType,
  },
  data() {
    return {
      table: {
        mname: "deviceType",
        key: "id",
        url: {
          list: "/admin/system/modelLibrary/list",
          del: "/admin/system/modelLibrary/del",
        },
        output: false,
      },
      actions: [
        {
          label: "新增",
          icon: "md-add",
          type: "info",
          onClick: this.toAdd,
          auth: "",
        },
        {
          label: "导入型号",
          icon: "md-cloud-upload",
          onClick: this.toImport,
          auth: "",
          type: "info",
        },
        {
          label: "下载模板",
          icon: "md-log-out",
          onClick: this.toDownload,
          auth: "system/commondescr/download",
          type: "info",
        },
      ],
      menus: [],
      filters: [
        {
          label: "型号名称",
          name: "modelName",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
      ],
      tableCols: [
        {
          // type: "selection",
          type: "index",
          title: "序号",
          width: 80,
          align: "center",
        },
        {
          title: "型号名称",
          key: "modelName",
          minWidth: 120,
          align: "left",
        },
        {
          title: "资产类型",
          key: "facilityType",
          minWidth: 120,
          align: "left",
        },
        {
          title: "品牌",
          key: "brandName",
          minWidth: 120,
          align: "left",
        },
        {
          title: "操作",
          align: "center",
          width: 150,
          key: "handle",
          fixed: "right",
          handle: ["edit", "delete"],
        },
      ],
    };
  },
  created() {},
  methods: {
    toAdd() {
      $utils.url.push({
        name: "deviceType_edit",
        query: { action: "add" },
      });
    },
    handleEdit(row) {
      let kv = row.id;
      $utils.url.push({
        name: "deviceType_edit",
        query: { action: "edit", kv: kv },
      });
    },
    toImport() {
      this.$Modal.success({
        closable: true,
        title: "导入模板",
        width: "1200px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <ImportDeviceType
              style={{ margin: "0", color: "#19be6b" }}
              refListTable={() => {
                this.search();
              }}
            ></ImportDeviceType>
          );
        },
      });
    },
    toDownload() {
      window.location.href =
        config.API_HOST + `/admin/system/modelLibrary/template/download`;
    },
  },
};
</script>
<style scoped></style>
